var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"partnersBar"},_vm._l((_vm.partnersList),function(partner){return _c('div',{key:partner.name,staticClass:"logoWrapper"},[_c('img',{staticClass:"partnerLogo",attrs:{"alt":partner.name,"src":partner.logo}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/reused-components/partnersBar/PartnersBar.vue